import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { CancelBookingContainer } = await import('@containers/Payment/CancelBooking');
    return {
        Component: CancelBookingContainer,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
